import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Timeslot} from '../shared/Timeslot';
import {MiniBookAdminService} from './mini-book-admin.service';

@Injectable()
export class TimeslotPublicService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getTimeslots(): Observable<Timeslot[]> {
    return this.http.get<any[]>(`${environment.url}${this.adminService.tenant}/timeslots`).pipe(
      map<any[], Timeslot[]>(data => data.map(value => Timeslot.createFromJson(value)))
    );
  }

  getTimeslot(id: number): Observable<Timeslot> {
    return this.http.get<any>(`${environment.url}${this.adminService.tenant}/timeslots/${id}`).pipe(
      map<any, Timeslot>(data => Timeslot.createFromJson(data))
    );
  }

}
